//#region src/js/pickup-availability-drawer.js
var PickupAvailabilityDrawer = class extends HTMLElement {
	connectedCallback() {
		if (this.initialized) return;
		this.initialized = true;
		this.onBodyClick = this.handleBodyClick.bind(this);
		this.querySelector("button").addEventListener("click", () => {
			this.hide();
		});
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
	}
	handleBodyClick(evt) {
		const target = evt.target;
		if (target !== this && !target.closest("pickup-availability-drawer") && target.id !== "ShowPickupAvailabilityDrawer") this.hide();
	}
	hide() {
		this.classList.remove("open");
		document.body.removeEventListener("click", this.onBodyClick);
		removeTrapFocus(this.focusElement);
	}
	show(focusElement) {
		this.focusElement = focusElement;
		this.classList.add("open");
		document.body.addEventListener("click", this.onBodyClick);
		trapFocus(this);
	}
};
if (!customElements.get("pickup-availability-drawer")) customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
//#endregion
